import TableauViz from "../components/tableau/TableauViz";

function Home(props) {
	return <>
		Home page
		<TableauViz />
	</>
}

export default Home